import {
  getAllBlocksThunk,
  postNewBlockThunk,
  getAllDistrictsThunk,
} from "./Blocks.Thunk";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  // states: [],
  blocks: [],
  districts: [],
  loading: false,
  error: false,
  data: [],
  status: "",
  message: "",
};

const BlockSlice = createSlice({
  name: "blockSlice",
  initialState,
  reducers: {
    nullState: (state, action) => {
      state.states = "";
      state.blocks = [];
      state.data = [];
      //   state.blocks = [];
      // state.loading = true;
      // state.status = action.meta.requestStatus; //for updating the status.
      // state.message = "loading";
    },
  },
  extraReducers: {
    [getAllBlocksThunk.pending]: (state, action) => {
      state.blocks = [];
      state.loading = true;
      state.states = "";
      state.error = false;
    },
    [getAllBlocksThunk.fulfilled]: (state, action) => {
      state.blocks = action.payload;
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "success";
    },
    [getAllBlocksThunk.rejected]: (state, action) => {
      state.blocks = [];
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },
    [postNewBlockThunk.pending]: (state, action) => {
      state.blocks = [];
      state.loading = true;
      state.status = action.meta.requestStatus;
      // state.message = action.error.message;
    },
    [postNewBlockThunk.fulfilled]: (state, action) => {
      // state.blocks = action.payload;
      state.loading = true;
      state.status = action.meta.requestStatus;
      //   state.message = action.error.message;
      // ,
    },
    [postNewBlockThunk.rejected]: (state, action) => {
      state.blocks = [];
      state.error = true;
      state.loading = false;
      state.status = action.meta.requestStatus;
      // state.message = action.error.message;
    },
    [getAllDistrictsThunk.pending]: (state, action) => {
      state.loading = true;
      state.districts = [];
      state.blocks = [];
      // state.status = action.meta.requestStatus;
      // state.message = action.error.message;
    },
    [getAllDistrictsThunk.fulfilled]: (state, action) => {
      state.loading = false;
      state.districts = action.payload;
      state.blocks = [];
      // state.status = action.meta.requestStatus;
      // state.message = action.error.message;
    },
    [getAllDistrictsThunk.rejected]: (state, action) => {
      state.loading = false;
      state.districts = [];
      state.blocks = [];

      state.error = action.payload;
      // state.status = action.meta.requestStatus;
      // state.message = action.error.message;
    },
  },
});

export const { nullState } = BlockSlice.actions;

export default BlockSlice.reducer;
